import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/client/link.js");
